import React from 'react'

export const br = <br />

export const singular = { count: 1 }
export const plural = { count: 2 }
